import { useFeatureGate } from "./useFeatureGate";

export function useUserHelpGuides() {
  const gate = useFeatureGate("user-help-guides");
  return {
    hasUserHelpGuidesAccess: gate.hasFeature("on"),
    isLoading: gate.isLoading,
  };
}
